// /app/javascript/controllers/dynamic_states_controller.js

import { Controller } from "@hotwired/stimulus"
import { get, post } from "@rails/request.js"

export default class extends Controller {
  static targets = ["stateSelect"]
  static values = {
    urlPattern: String,
    updateUrl: String
  }

  connect() {
    // CORRECTED: Use the "attribute contains" selector (*=) to find the element
    // This accommodates multiple actions on the same element.
    const countrySelect = this.element.querySelector('[data-action*="dynamic-states#update"]');
    if (countrySelect) {
      if (!countrySelect.value) {
        this.stateSelectTarget.disabled = true;
      }
    } else {
      console.warn("Dynamic states controller could not find a country select element.");
      this.stateSelectTarget.disabled = true;
    }
  }

  update(event) {
    const countryId = event.target.value;
    this.fetchStatesForCountry(countryId);
  }

  async fetchStatesForCountry(countryId) {
    const stateSelect = this.stateSelectTarget;
    stateSelect.innerHTML = '<option value="">Loading states...</option>';
    stateSelect.disabled = true;
    if (!countryId) {
      stateSelect.innerHTML = '<option value="">Select a country first</option>';
      return;
    }
    const url = this.urlPatternValue.replace('DYNAMIC_COUNTRY_ID_REPLACE', encodeURIComponent(countryId));
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch states: ${response.statusText}`);
      }
      const states = await response.json();
      this.populateStateOptions(states);
    } catch (error) {
      console.error("Error fetching or processing states:", error);
      this.stateSelectTarget.innerHTML = '<option value="">Error loading states</option>';
      this.stateSelectTarget.disabled = true;
    }
  }

  populateStateOptions(states) {
    const stateSelect = this.stateSelectTarget;
    stateSelect.innerHTML = '';
    let optionsHtml = '<option value="">Select State/Province</option>';
    if (states && states.length > 0) {
      states.forEach(state => {
        optionsHtml += `<option value="${state.id}">${this.escapeHtml(state.name)}</option>`;
      });
      stateSelect.disabled = false;
    } else {
      optionsHtml += '<option value="">N/A</option>';
      stateSelect.disabled = true;
    }
    stateSelect.innerHTML = optionsHtml;
    stateSelect.dispatchEvent(new Event('change'));
  }

  async updateOrderSummary(event) {
    // For shipping form, always update
    if (this.element.closest('#shipping-address-card')) {
        this.performUpdate(event);
        return;
    }

    // For billing form, only update if ship_to_billing is checked
    const shipToBillingCheckbox = document.getElementById('invoice_ship_to_billing');
    if (shipToBillingCheckbox && shipToBillingCheckbox.checked) {
        this.performUpdate(event);
    }
  }

  async performUpdate(event) {
    const form = this.element.closest("form");
    if (!form) return;

    const formData = new FormData(form);
    if(event) {
      formData.set(event.target.name, event.target.value);
    }

    await post(this.updateUrlValue, {
      body: formData,
      responseKind: "turbo-stream"
    });
  }

  escapeHtml(unsafe) {
    if (unsafe === null || typeof unsafe === 'undefined') return '';
    return unsafe
          .toString()
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#039;");
  }
}